<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="p-3 pb-0 card-header">
                                <div class="d-flex justify-content-between">
                                    <h6 class="mb-2 ms-2">Deleted Records</h6>
                                    <button class="btn btn-danger" @click="deleteAll">Delete All</button>
                                </div>
                            </div>
                            <div class="card-body">
                                <div style="margin-bottom: 10px;">
                                    <p><b>CAUTION:</b> This is a protected view of <router-link
                                            class="text-dark font-weight-bolder" to="/home">
                                            app.nexonautomation.com
                                        </router-link>,
                                        If you're not certain of what this actions/data means,
                                        Please <b>DO NOT perfom any action</b> <router-link
                                            class="text-dark font-weight-bolder" to="/home">
                                            go back home
                                        </router-link>instead. Thank you.</p>
                                </div>
                                <div class="table-responsive">
                                    <table id="usersTable" class="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Recorded on</th>
                                                <th>Recorded by</th>
                                                <th>Date</th>
                                                <th>Hours</th>
                                                <th>Project</th>
                                                <th>Activity</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <!-- Los datos se insertarán aquí -->
                                            <tr v-for="record in time_records" :key="record.time_record_id">
                                                <td>{{ formatRecordedOn(record.recorded_on) }}</td>
                                                <td>{{ record.name }} {{ record.last_name }}</td>
                                                <td>{{ formatDate(record.date) }}</td>
                                                <td>{{ record.total_hours }}</td>
                                                <td>{{ record.client }} - {{ record.project }}</td>
                                                <td>{{ record.activity }}</td>
                                                <td>
                                                    <!-- Botón de Restaurar -->
                                                    <button class="btn btn-success btn-sm me-2"
                                                        @click="restoreRecord(record.time_record_id)">
                                                        Restore
                                                    </button>
                                                    <!-- Botón de Borrar -->
                                                    <button class="btn btn-danger btn-sm me-2"
                                                        @click="deleteRecord(record.time_record_id)">
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

import axios from 'axios';
import { RouterLink } from 'vue-router';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

// Estado para almacenar los datos de los usuarios
const time_records = ref([]);

const fetchData = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/get-deleted-records`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        time_records.value = response.data.data; // Asigna los datos a tu variable `users`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
};

const formatRecordedOn = (IsoDate) => {
    const date = new Date(IsoDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear().toString();
    const time = date.toTimeString().split(' ')[0];
    return `${day}/${month}/${year} ${time}`;
}

const formatDate = (IsoDate) => {
    const date = new Date(IsoDate);
    const day = date.getDate() + 1;
    const month = date.getMonth() + 1;
    const year = date.getFullYear().toString();
    return `${day}/${month}/${year}`;
}

const restoreRecord = async (id) => {

    const confirmMsg = '¿Estás segur@ de restaurar este registro?'
    if (confirm(confirmMsg)) {
        try {
            const response = await axios.post(`${API_BASE_URL}/restore-record`, { time_record_id: id }, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            if (response.data.msg) {
                alert(`${response.data.msg}`)
                await fetchData();
            }
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    }
}

const deleteRecord = async (id) => {
    const confirmMsg = '¿Estás segur@ de eliminar PERMANENTEMENTE este registro?, Esta acción NO podrá deshacerse'
    if (confirm(confirmMsg)) {
        try {
            const response = await axios.post(`${API_BASE_URL}/delete-record`, { time_record_id: id }, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            if (response.data.msg) {
                alert(`${response.data.msg}`)
                await fetchData();
            }
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    }
}

const deleteAll = async () => {
    const confirmMsg = '¿Estás segur@ de eliminar PERMANENTEMENTE TODOS estos registros?, Esta acción NO podrá deshacerse'
    if (confirm(confirmMsg)) {
        try {
            const response = await axios.post(`${API_BASE_URL}/delete-all-records`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            if (response.data.msg) {
                alert(`${response.data.msg}`)
                await fetchData();
            }
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    }
}

onMounted(() => {
    fetchData();
});

</script>